import type { Item } from '@dcc/rules/content/types.ts';
import type { InventoryEntry } from '@dcc/rules/rules/inventory.ts';
export type InventorySort = 'name' | 'value-high' | 'value-low' | 'quantity';
export function inventoryMatches(item: Item | undefined, category: string, query: string, id: string): boolean {
  const text = `${item?.name ?? id} ${item?.description ?? ''} ${item?.notes ?? ''}`.toLocaleLowerCase();
  if (!text.includes(query.trim().toLocaleLowerCase())) return false;
  if (!category) return true;
  if (category === 'weapon') return Boolean(item?.weaponAttackId);
  if (category === 'pet') return item?.petGear === true;
  if (category === 'scrap') return id === 'scrap';
  if (category.startsWith('slot:')) return item?.slot === category.slice(5);
  return item?.kind === category;
}
export function inventoryRows(entries: readonly InventoryEntry[], lookup: (id: string) => Item | undefined, category: string, query: string, sort: InventorySort): InventoryEntry[] {
  return entries.filter(e => inventoryMatches(lookup(e.itemId), category, query, e.itemId)).slice().sort((a, b) => {
    const ai = lookup(a.itemId), bi = lookup(b.itemId);
    if (sort === 'value-high' || sort === 'value-low') {
      const av = ai?.goldValue, bv = bi?.goldValue;
      if (av === undefined && bv !== undefined) return 1;
      if (bv === undefined && av !== undefined) return -1;
      if (av !== undefined && bv !== undefined && av !== bv) return sort === 'value-high' ? bv - av : av - bv;
    }
    if (sort === 'quantity' && a.quantity !== b.quantity) return b.quantity - a.quantity;
    return (ai?.name ?? a.itemId).localeCompare(bi?.name ?? b.itemId) || a.itemId.localeCompare(b.itemId);
  });
}
export function batchQuantity(value: string): number | null {
  const n = Number(value); return value.trim() && Number.isInteger(n) && n >= 1 && n <= 99 ? n : null;
}
